import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl


const GetlistePagesReservation = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/all" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const AddPageReservation = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.post("/rabat-zoo/page-reservation/api/add",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const updatePageReservation = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.put("/rabat-zoo/page-reservation/api/update",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const disablePageReservation = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/disable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const removePageReservation = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/remove/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const enablepageReservation = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/enable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const UploadFilePageReservation = async (formData) =>{

    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.post("/rabat-zoo/page-reservation/api/upload",formData ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
  }




export {GetlistePagesReservation,AddPageReservation,UploadFilePageReservation,updatePageReservation, disablePageReservation, enablepageReservation,removePageReservation}
